'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _regeneratorRuntime = require('@babel/runtime/regenerator');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var React = require('react');
var Loads = require('react-loads-next');
var useDebounce = require('use-debounce');
var bumbag = require('bumbag');
var _get = require('lodash/get');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Loads__namespace = /*#__PURE__*/_interopNamespace(Loads);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);

function AddressField(props) {
  var onBlur = props.onBlur,
      onChange = props.onChange,
      value = props.value;

  var _React$useState = React__default["default"].useState(value || ''),
      searchValue = _React$useState[0],
      setSearchValue = _React$useState[1];

  var _React$useState2 = React__default["default"].useState(),
      selectedOption = _React$useState2[0],
      setSelectedOption = _React$useState2[1];

  React__default["default"].useEffect(function () {
    setSearchValue(value);
  }, [value]);
  var getSuggestions = React__default["default"].useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(_ref) {
      var searchText, suggestions, options;
      return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              searchText = _ref.searchText;

              if (searchText) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", []);

            case 3:
              _context.next = 5;
              return new Promise(function (res, rej) {
                if (_get__default["default"](window, 'google.maps.places.AutocompleteService')) {
                  var autocompleteService = new window.google.maps.places.AutocompleteService();
                  autocompleteService.getPlacePredictions({
                    input: searchText,
                    componentRestrictions: {
                      country: 'au'
                    },
                    types: ['address']
                  }, function (predictions, status) {
                    res(predictions || []);
                  });
                }
              });

            case 5:
              suggestions = _context.sent;
              // @ts-expect-error TS(2339): Property 'map' does not exist on type 'unknown'.
              options = suggestions.map(function (item) {
                return {
                  key: item.id,
                  label: item.description,
                  value: item.description
                };
              });
              return _context.abrupt("return", options);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []); // @ts-expect-error TS(2554): Expected 3 arguments, but got 1.

  var suggestionsLoader = Loads__namespace.useDeferredLoads(getSuggestions);
  var suggestions = suggestionsLoader.response || [];

  var _useDebouncedCallback = useDebounce.useDebouncedCallback(suggestionsLoader.load, 500),
      debouncedSuggestionsLoad = _useDebouncedCallback[0];

  var handleBlur = React__default["default"].useCallback(function (e) {
    if (!selectedOption && !value) {
      setSearchValue('');
    }

    onBlur && onBlur({
      target: {}
    });
  }, [onBlur, selectedOption, value]);
  var handleChange = React__default["default"].useCallback(function (e, _ref3) {
    var popover = _ref3.popover;
    var value = e.target.value;
    popover.show();
    setSearchValue(value); // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.

    setSelectedOption();
    onChange && onChange('');
    debouncedSuggestionsLoad({
      searchText: value
    });
  }, [debouncedSuggestionsLoad, onChange]);
  var handleSelect = React__default["default"].useCallback(function (suggestion, _ref4) {
    var popover = _ref4.popover;
    setSearchValue(suggestion.value);
    setSelectedOption(suggestion);
    popover.hide();
    onChange && onChange(suggestion.value);
  }, [onChange]); // TODO: When Fannypack <Autocomplete> is released, use that instead.

  return /*#__PURE__*/React__default["default"].createElement(bumbag.Popover.State, {
    gutter: 0
  }, function (popover) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Popover.Disclosure, null, function (props) {
      return (
        /*#__PURE__*/
        // @ts-expect-error TS(2322): Type '{ onBlur: (e: any) => void; onChange: (e: an... Remove this comment to see the full error message
        React__default["default"].createElement(bumbag.InputField, _extends__default["default"]({}, props, {
          onBlur: handleBlur,
          onChange: function onChange(e) {
            return handleChange(e, {
              popover: popover
            });
          },
          value: searchValue,
          autoComplete: "off"
        }))
      );
    }), /*#__PURE__*/React__default["default"].createElement(bumbag.Popover, {
      padding: "0",
      width: "100%",
      isFullWidth: true
    }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Menu, null, suggestions.map(function (suggestion, i) {
      return /*#__PURE__*/React__default["default"].createElement(bumbag.Menu.Item, {
        key: i,
        onClick: function onClick() {
          return handleSelect(suggestion, {
            popover: popover
          });
        }
      }, " ", suggestion.label);
    })))));
  });
}

exports["default"] = AddressField;
